import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isModalVisible : false
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchSlice: (state, action) => {
      const {
        isModalVisible
      } = action.payload;

      // Update state with new filter values
      state.isModalVisible = isModalVisible;
    },
  },
});

export const { setSearchSlice } = searchSlice.actions;
export default searchSlice.reducer;
